export default __webpack_public_path__ + "static/media/share-red-envelope-cover.9eeb2428.svg";